<div class="draft-list-container" tid="draft-list" loading-spin [isLoading]="reloading" [loadingSize]="'big'"
    tabindex="-1" (keydown)="onKeydown($event)">
    <div class="no-data" [style.display]="showNoData()">
        <span>No Data Found</span>
    </div>
    <div #listContainer tid="draft_list" class="draft-list" infiniteScroll [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="150" [scrollWindow]="false"
        [infiniteScrollDisabled]="loadingMore || !draftList.hasNext" (scrolled)="onScrolled()">
        <div class="item" *ngFor="let item of draftList; index as i;trackBy:trackByFn" (click)="onItemSelect(item, i)"
            [ngClass]="selectedItemMap.has(item.id) ? 'active' : ''" (contextmenu)="onContextMenu($event, item, i)"
            (touchstart)="touchstart()" (touchend)="touchend($event, item, i)"
            (dblclick)="onItemDoubleClick($event, item)">
            <draft-list-item [thread]="item" [sortInfo]="sortInfo"></draft-list-item>
        </div>
        <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
    </div>
</div>